function textSearchFilter() {
    return {
        componentName: 'textSearchFilter',
        baseStyle: {
            position: 'relative'
        }
    };
}

export { textSearchFilter as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dFNlYXJjaEZpbHRlci5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3RoZW1lL2NvbXBvbmVudHMvdGV4dFNlYXJjaEZpbHRlci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb21wb25lbnRTdHlsZSB9IGZyb20gJy4uL3R5cGVzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdGV4dFNlYXJjaEZpbHRlcigpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ3RleHRTZWFyY2hGaWx0ZXInLFxuICAgIGJhc2VTdHlsZToge1xuICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZSdcbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxnQkFBZ0IsR0FBQTtJQUN0QyxPQUFPO0FBQ0wsUUFBQSxhQUFhLEVBQUUsa0JBQWtCO0FBQ2pDLFFBQUEsU0FBUyxFQUFFO0FBQ1QsWUFBQSxRQUFRLEVBQUU7QUFDWDtLQUNGO0FBQ0g7Ozs7In0=
